<template>
  <CommonModal>
    <template slot="header">
      <h3>Change Order</h3>
    </template>
    <template slot="body">
      <draggable v-model="form.productList">
        <div v-for="item in form.productList" :key="item.prodId" class="order-box">
          {{ item.prodName }}
        </div>
      </draggable>
    </template>
    <template slot="footer">
      <slot name="footer">
      </slot>
    </template>
  </CommonModal>
</template>

<script>
import {getProdList, updateProdTypeOrder} from "@/api/prodtype";
import draggable from 'vuedraggable'
import CommonModal from "@/components/modal/CommonModal";

export default {
  components: {
    CommonModal ,
    draggable
  },
  data() {
    return {
      form : {
        productList: [],
      },
    };
  },
  methods: {
    async fetchData(lang, level, upperId){
      try {
        let response = await getProdList(lang, level, upperId);
        this.form.productList = response.data.prodList;
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    async saveOrder() {
      await this.form.productList.forEach(function (item, index) {
        item.prodSort = index;
      });
      await updateProdTypeOrder(this.form);
    },
  }
}
</script>

<style>
</style>